import { FC, ReactNode } from 'react';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import CountrySelect, { BaseCountrySelectProps } from 'components/forms/CountrySelect';
import { CustomerInfoKeyType } from 'types/customer';

export const defaultFieldsOfTaxCountry: CustomerInfoKeyType[] = ['tax_residence_country'];

export interface TaxCountryFormutil {
    tax_residence_country: string;
}

interface TaxCountryProps extends FormGroupProps {
    countrySelectProps?: Omit<BaseCountrySelectProps, 'isSSN'>;
    disabled?: boolean;
    label?: ReactNode;
    isSSN: boolean;
}

const TaxCountry: FC<TaxCountryProps> = ({
    label = __('Country/Region of Tax Residence'),
    isSSN,
    disabled,
    countrySelectProps,
    ...restProps
}) => {
    return (
        <FormGroup
            label={label}
            name="tax_residence_country"
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (!value) {
                    return __('请选择纳税地区');
                }

                return true;
            }}
            {...restProps}>
            <CountrySelect
                isSSN={isSSN}
                disabled={disabled}
                fieldName="tax_residence_country"
                {...countrySelectProps}
            />
        </FormGroup>
    );
};

export default TaxCountry;
